export const displaySlackChannelName = (channelName: string) => {
  return channelName[0] === '@' ? channelName : `#${channelName}`;
};
